import React from 'react';

const About = () => {
  return (
    <section id="about" className="relative py-20 px-6 overflow-hidden">
      {/* Tech background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-[15%] w-24 h-24 border-4 border-blue-400/20 rounded-lg animate-float-1"></div>
        <div className="absolute bottom-1/3 right-[20%] w-20 h-20 border-3 border-blue-400/20 rounded-full animate-float-2"></div>
        <div className="absolute top-1/3 right-[30%] w-16 h-16 border-t-4 border-r-4 border-blue-400/20 transform animate-spin-slow"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold mb-12 text-center text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">
          About Me
        </h2>

        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* Profile Image - Large with glowing effect */}
          <div className="relative group">
            <div className="absolute -inset-2 bg-blue-500/20 rounded-full blur-lg group-hover:bg-blue-400/30 transition-all duration-500"></div>
            <img
              src="profile1.png"
              alt="Aniket Adarsh"
              className="relative rounded-full w-72 h-72 object-cover border-2 border-blue-500/30 z-10 transition-transform duration-500 group-hover:scale-105"
            />
          </div>

          {/* Text Content with tech card style */}
          <div className="flex-1 bg-gradient-to-br from-gray-900 to-gray-800 p-8 rounded-2xl border border-gray-700/50 shadow-2xl shadow-blue-500/10">
            <div className="space-y-6">
              <p className="text-lg text-gray-300 leading-relaxed">
                <span className="text-blue-400 font-medium">Final Year B.Tech student</span> at Tula's Institute, Dehradun, 
                majoring in <span className="text-cyan-400">Computer Science</span> with a minor in 
                <span className="text-cyan-400"> Artificial Intelligence and Machine Learning</span>. 
                Passionate about solving real-world problems through technology and innovation.
              </p>

              <p className="text-lg text-gray-300 leading-relaxed">
                As a <span className="text-blue-400 font-medium">Full Stack Developer</span>, I've built several end-to-end projects — 
                from geofencing-based attendance systems to AI-powered safety wearables. 
                My tech stack includes <span className="text-cyan-400">Python, C, JavaScript</span>, and modern frameworks.
              </p>

              <p className="text-lg text-gray-300 leading-relaxed">
                Currently diving deep into <span className="text-blue-400 font-medium">Machine Learning</span> and <span className="text-blue-400 font-medium">Data Science</span>, 
                working on cutting-edge projects involving emotion detection, sentiment analysis, and weapon detection.
              </p>

              <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-gray-800/50 p-4 rounded-lg border border-gray-700/50">
                  <div className="text-blue-400 text-xl mb-2">📍</div>
                  <h4 className="text-white font-medium">Location</h4>
                  <p className="text-gray-400">Dehradun, India</p>
                </div>
                <div className="bg-gray-800/50 p-4 rounded-lg border border-gray-700/50">
                  <div className="text-blue-400 text-xl mb-2">🎓</div>
                  <h4 className="text-white font-medium">Education</h4>
                  <p className="text-gray-400">B.Tech CSE (AI/ML)</p>
                </div>
                <div className="bg-gray-800/50 p-4 rounded-lg border border-gray-700/50">
                  <div className="text-blue-400 text-xl mb-2">💼</div>
                  <h4 className="text-white font-medium">Status</h4>
                  <p className="text-gray-400">Open to opportunities</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Animation styles */}
      <style jsx global>{`
        @keyframes float-1 {
          0%, 100% { transform: translateY(0) rotate(12deg) scale(1); }
          50% { transform: translateY(-25px) rotate(12deg) scale(1.05); }
        }
        @keyframes float-2 {
          0%, 100% { transform: translateY(0) scale(1); }
          50% { transform: translateY(20px) scale(1.1); }
        }
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .animate-float-1 { animation: float-1 7s ease-in-out infinite; }
        .animate-float-2 { animation: float-2 6s ease-in-out infinite; }
        .animate-spin-slow { animation: spin-slow 25s linear infinite; }
      `}</style>
    </section>
  );
};

export default About;